export const ROUTE_BACK_IN_STOCK = '/back-in-stock';
export const SUBROUTE_AB_TESTS = '/ab-tests';
export const SUBROUTE_SCHEDULE = '/schedule';
export const SUBROUTE_CREATE = '/create';
export const SUBROUTE_EDITOR = '/editor';
export const SUBROUTE_CREATE_SPLIT_TEST = '/create_split_test';
export const SUBROUTE_EDIT_SPLIT_TEST = '/edit_split_test';

export const BIS_QUERY_KEY_PREFIX = 'back-in-stock';
export const BIS_SPLIT_TESTS_QUERY_KEY_PREFIX = 'back-in-stock/split-tests';
export const BIS_SCHEDULE_EVENTS_QUERY_KEY_PREFIX =
  'back-in-stock-schedule-events';
export const LARGE_ENTITY_FETCH_LIMIT = 100;

export const SUBROUTE_ADMIN_TEMPLATES = '/back-in-stock';

export const SPLIT_TEST_TOOLTIP_MESSAGE =
  'There must be at least two available popups to create an A/B test. Create a new popup or clone an existing one, make the changes you want to test, and try again.';

export const LIST_BREADCRUMB_TEXT = 'View all BIS popups';
